<template>
  <div v-if="renderComponent">
    <div>
      <h5 class="vue-title pull-left custom-header" >
        <strong>ユーザ一覧</strong>
      </h5>

      <p
        class="float-right btn-add-user"
        v-if="checkPermisssion('PARTNER_USER', false)"
      >
        {{ $t("ADD") }}
        <a href="#/createuserinfo">
          <em class="fas fa-plus-circle"></em>
        </a>
      </p>

      <b-input-group 
        class="pull-right search-text-box search-user"
      >
        <template v-slot:prepend>
          <b-input-group-text @click="onSerach">
            <em class="fa fa-search"></em>
          </b-input-group-text>
        </template>
        <b-form-input
          size="sm"
          @keyup.enter="onSerach"
          v-model="searchKeyword"
          autocomplete="off"
        ></b-form-input>
      </b-input-group>
    </div>

    <c-table
      :fields="tableHeaders"
      :table-data="patientList.list"
      :per-page="10"
      striped
      hover
      :total="patientList.pageTotal"
      :delete="onclickDeleteUser"
      :update="showStatusChangePopup"
      :edit="onClickEditButton"
      :dbClick="dbClickTableRow"
      :sortTable="sortTable"
      :isBusy="isBusy"
      :pagination="pagination"
      :countPerPage="currentPage"
    ></c-table>
    <nav>
      <div class="pagination-module">
        <b-pagination
          :total-rows="patientList.pageTotal"
          @change="pagination"
          :per-page="10"
          v-model="currentPage"
          :prev-text="$t('FORWARD')"
          :next-text="$t('NEXT')"
        />
      </div>
    </nav>

    <b-modal id="modal-delete" hide-footer>
      <template v-slot:modal-title>{{ $t("DELETECONFIRMATION") }}</template>
      <p class="my-2 wrapText">
        {{
          selectedItemNameForDelete.last_name +
            " " +
            selectedItemNameForDelete.first_name
        }}
        {{ $t("DELETECONFIRMATIONCOMMOM") }}
      </p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-danger"
            class="buttons-align-right"
            size="sm"
            @click="deleteItem()"
            >{{ $t("DELETE") }}</b-button
          >

          <b-button
            variant="outline-secondary"
            class="buttons-align-right"
            size="sm"
            @click="$bvModal.hide('modal-delete')"
            >{{ $t("CANCEL") }}</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-Status" hide-footer @hidden="close">
      <template v-slot:modal-title>{{
        $t("STATUSCHANGECONFIRMATION")
      }}</template>
      <p>ステータスを変更してもよろしいですか？</p>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right"
            @click="StatusChange()"
            >{{ $t("SUBMIT") }}</b-button
          >
          <b-button
            class="buttons-align-right"
            variant="outline-secondary"
            size="sm"
            @click="close"
          >
            {{ $t("CANCEL") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import cTable from "@/components/Table.vue";
import { mapGetters } from "vuex";
import { checkPermisssion } from "@/shared/utils.js";
import {
  PARTNER_PATIENT_LIST,
  DELETE_PARTNER_PATIENT,
  UPDATE_STATUS_PARTNER_PATIENT,
} from "@/store/actions.type";

export default {
  name: "partners-list",
  data() {
    return {
      searchKeyword: "", // searchbox v-modal
      currentPage: 1, // pagination current page
      renderComponent: true,
      checkPermisssion: checkPermisssion, //injecting check permission method to component
      isBusy: true, //loader
      tableHeaders: [], // table headders
      selectedItemNameForDelete: "", // Storing selected item from table.
      sortField: "",
      sortDirection: false
    };
  },
  components: { cTable },
  computed: {
    ...mapGetters(["patientList"])
  },
  methods: {
    /**
     * View Detials of the  table row
     * Input @param {Number} userId Seleted Row id to View
     * Output  @param {Number} userId  append to routing Params then Redirect to Details page
     */
    dbClickTableRow(record, index) {
      this.$router.push({
        name: "userDetails",
        params: { id: record.user_id }
      });
    },
    /**
     * Show Delete Modal
     * Input @param {object} row Seleted Row to Delete
     * Output PopUp the Delete Modal
     */
    onclickDeleteUser(row) {
      this.selectedItemNameForDelete = row;
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-delete");
    },
    /**
     * Edit the table row
     * Input @param {Number} userId Seleted Row id to Edit
     * Output  @param {Number} userId  append to routing Params then Redirect to edit page
     */
    onClickEditButton(row) {
      this.$router.push({
        name: "editpatient",
        params: { id: row.id }
      });
    },
    /**
     * Status function for table Row
     * Input 1,@param {Number} userID  selected Row ID 2,@param {string} status  (Active or Inactive)
     * Output @param {boolean}   data.status  status of the api call (true or false)
     */
    async StatusChange() {
      this.$bvModal.hide("modal-Status");
      /* Show loader */
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let selectedItemId = _.get(this.selectedItemForDelete, "id", 0);
      if (selectedItemId) {
        /* Call api to update status */
        let status = _.get(this.selectedItemForDelete, "status", "");
        let response = await this.$store.dispatch(
          UPDATE_STATUS_PARTNER_PATIENT,
          {
            id: selectedItemId,
            status: status == "active" ? "inactive" : "active"
          }
        );

        /* hide loader */
        this.isLoading.hide();
        this.isBusy = true;
        if (_.get(response, "status", false)) {
          this.$toast.success({
            message: _.get(response, "message", "")
          });
        } else {
          this.$toast.error({
            message: _.get(response, "message", "")
          });
        }
        /* Call list after status update */

        this.pagination(this.currentPage);
      }
    },
    /* onclick pagination.  */
    pagination(page) {
      this.loadTableData(page);
    },
    /**
     * To load the table data
     * Input @param {page} currentPageCount the page number of data you want
     * Output {object} table data
     */
    async loadTableData(page) {
      this.currentPage = page;
      this.isBusy = true;
      await this.$store.dispatch(PARTNER_PATIENT_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });

      this.isBusy = false;
    },
    /**
     * Show Status Change Modal
     * Input @param {object} row Seleted Row to Change status of it
     * Output PopUp the Status Change Modal
     */
    showStatusChangePopup(row) {
      this.selectedItemForDelete = row;
      this.$bvModal.show("modal-Status");
    },
    /**
     * Delete function for table Row
     * Input @param {Number} userID selected Row ID
     * Output @param {Boolean}   data.status  Boolean status Api call
     */
    async deleteItem() {
      this.$bvModal.hide("modal-delete");
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
      let response = await this.$store.dispatch(DELETE_PARTNER_PATIENT, {
        id: this.selectedItemForDelete.id
      });

      if (_.get(response, "status", false)) {
        this.isLoading.hide();
        this.isBusy = true;
        this.$toast.success({
          message: _.get(response, "message", "")
        });
        if (this.patientList.list.length === 1) {
          this.pagination(1);
        } else {
          this.pagination(this.currentPage);
        }
      } else {
        this.$toast.error({
          message: _.get(response, "message", "")
        });
      }
    },
    /**
     * Sort function on  table
     * Input 1.@param {String} sortField name of the Field , 2.@param {String} sortDirection Direction of the Sort(Ascending or Descending)
     * Output @param {List}   response.list  Filtered List
     */
    async sortTable(field, direction) {
      this.isBusy = true;
      this.sortField = field;
      this.sortDirection = direction;
      await this.$store.dispatch(PARTNER_PATIENT_LIST, {
        search_query: this.searchKeyword,
        field: this.sortField,
        sort: this.sortDirection,
        page: this.currentPage
      });

      this.isBusy = false;
    },
    /* close modal pop */
    close() {
      this.renderComponent = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },

    /**
     * onSearch function on  table
     * Input @param {String} search_query Search keyword
     * Output @param {List}   response.list  Filtered List
     */
    onSerach() {
      this.pagination(1);
    }
  },
  created() {
    this.$store
      .dispatch(PARTNER_PATIENT_LIST, { field: "id", sort: "desc" })
      .then(data => {
        this.isBusy = false;
      });

    this.tableHeaders = [
      {
        key: "user.userid",
        label: this.$t("ID"),
        class: "text-left",
        sortable: true
      },
      {
        key: "first_last_name",
        label: "ユーザー姓名",
        class: "text-left",
        sortable: true
      },
      {
        key: "custom_address", //need to append address.prepecture+ address.prepecture
        label: this.$t("STREETADDRESS"),
        class: "text-left",
        sortable: true
      },
      {
        key: "contact_no",
        label: this.$t("PHONENUMBER"),
        sortable: true,
        class: "text-left"
      }
    ];
    if (checkPermisssion("PARTNER_USER", false)) {
      this.tableHeaders.push({
        key: "status",
        label: this.$t("STATUS"),
        sortable: false
      });
      this.tableHeaders.push({
        key: "actions",
        label: this.$t("ACTION"),
        sortable: false
      });
    } else {
      this.tableHeaders.push({
        key: "status_disable",
        label: this.$t("STATUS"),
        sortable: false
      });
    }
  }
};
</script>
<style scoped>
.addBtn {
  font-size: 17px;
  margin-top: 14px;
  margin-left: 20px;
  margin-right: 20px;
}
.searchBtn {
  width: 200px;
  margin: 10px 0px;
  height: 10px;
}
.btn-add-user{
  font-size: 17px;    margin-top: 14px;margin-left:20px
}
.search-user{
  width:200px;margin:10px 00px;
}
</style>
